
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./mobxreactlite.cjs.production.min.js')
} else {
  module.exports = require('./mobxreactlite.cjs.development.js')
}
